<template>
    <div class="relative">
        <div class="absolute inset-0 flex items-center" aria-hidden="true">
            <div class="w-full border-t border-gray-200"></div>
        </div>
        <div class="relative flex justify-center">
            <span class="px-2 bg-white text-sm text-gray-300">
                <slot></slot>
            </span>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
